import { useQuery, UseQueryResult } from 'react-query';
import { getProcedureCategories } from '../utils/urls';
import { getTokenWithType } from './useAuth';
import { ProcedureCategoryType } from 'types/procedureBuilder';

async function fetchCategories(): Promise<APIResult> {
  const response = await fetch(getProcedureCategories, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  // debugger;
  return response.json();
}

export type APIResult = { Data: Array<ProcedureCategoryType> | undefined}
export type TResult = APIResult | undefined;
export type TError = { message: string };
export type TVariables = {
  id: number | string;
};

function useFetchProcedureCategories(): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_procedure_category'],
    async () => {
      const fetchResponse = await fetchCategories();
      return fetchResponse;
    },
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}
export { useFetchProcedureCategories };
